import { useState } from 'react';
import { networks, wallets } from '../../../helpers/helperFunctions';
import { ArrowPolygon, Flexed, Select } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import {
  Icon,
  IconSettingsCheckboxOff,
  IconSettingsCheckboxOn
} from '../../../styles/Icons';
import { SectionSeparator } from '../../../styles/stylesStyled';
import { WalletsType } from '../../../types/types';
import { CollapsibleAbsolute, SelectDropDown } from './SelectNetwork.styles';

interface SelectNetworkProps {
  onChange: (network: WalletsType) => void;
  value: WalletsType | null;
  disabled?: boolean;
}

export const SelectNetwork = ({
  onChange,
  value,
  disabled
}: SelectNetworkProps) => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  return (
    <Select
      disabled
      isOpen={isOpenDropdown}
      onClick={() => setIsOpenDropdown(!isOpenDropdown)}>
      <span>
        {value ? (
          <Flexed center>
            <img src={value?.icon} alt='checked' />
            <span>{value?.wallet}</span>
          </Flexed>
        ) : (
          <div style={{ color: color.colors.neutral700 }}>
            Select Blockchain
          </div>
        )}
      </span>

      {!disabled && (
        <>
          <ArrowPolygon
            direction={isOpenDropdown ? 'down' : 'right'}
            customColor={color.colors.neutral700}
          />
          <CollapsibleAbsolute isOpen={isOpenDropdown}>
            <SelectDropDown>
              {networks.map((wallet, index) => (
                <div key={index}>
                  <Flexed
                    between
                    onClick={() => {
                      onChange(wallet);
                      setIsOpenDropdown(!isOpenDropdown);
                    }}
                    key={index}
                    style={{ width: '100%' }}>
                    <Flexed center>
                      <img
                        src={wallet.icon}
                        alt='checked'
                        style={{ marginRight: 10, width: 14 }}
                      />
                      <span>{wallet.wallet}</span>
                    </Flexed>

                    <Icon color={color.colors.secondary100}>
                      {value?.index === index ? (
                        <IconSettingsCheckboxOn size={'24'} />
                      ) : (
                        <IconSettingsCheckboxOff size={'24'} />
                      )}
                    </Icon>
                  </Flexed>
                  <SectionSeparator margin='0' />
                </div>
              ))}
            </SelectDropDown>
          </CollapsibleAbsolute>
        </>
      )}
    </Select>
  );
};
